<script>
    import { Notes } from "../../../Components/Common/index.svelte";

    import { NoteTypes } from "../../../Utils/utilConstants.svelte";

    export let encounterID;
    export let encounterHasNotes = false;
    export let reloadPatientDetails = () => {};
    export let encounterDoctorGroupId = null;
</script>

<Notes
    noteOwnerID={encounterID}
    noteType={NoteTypes.PatientEncounter}
    sectionTitle="Encounter Notes"
    hasNotes={encounterHasNotes}
    onFinishModifyNote={reloadPatientDetails}
    {encounterDoctorGroupId}
/>
